import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { HttpAlertService } from '../../services/http-alert.service';
import { MustMatch } from '../../shared/inputs-match/inputs-match';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  showCodeModal = false;
  code: string;
  isLoading1 = false;
  isLoading2 = false;
  codeError = false;

  constructor(
    private authService: AuthorizationService,
    private fb: FormBuilder,
    private router: Router,
    private translate: TranslateService,
    private httpAlertService: HttpAlertService) { }

  ngOnInit(): void {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password1: ['', Validators.required],
      password2: ['', Validators.required]
    }, {
      validator: MustMatch('password1', 'password2')
    });
  }

  get f() { return this.forgotPasswordForm.controls; }

  public onChangePassword() {
    if (this.forgotPasswordForm.valid) {
      this.isLoading1 = true;

      this.authService.changePassword(this.forgotPasswordForm.value).subscribe(data => {
        if (data.success) {
          this.httpAlertService.info(this.translate.instant(data.message));
          this.showCodeModal = true;
        }
        this.isLoading1 = false;
      }, (err) => {
        this.httpAlertService.error(this.translate.instant(err.error.message));
        this.isLoading1 = false;
      });
    }
  }

  public verifyCode() {
    if (!this.code || this.code.length !== 6) {
      this.codeError = true;
    } else {
      this.isLoading2 = true;

      const obj = {
        email: this.forgotPasswordForm.value.email,
        code: this.code
      };

      this.authService.verifyChangePasswordCode(obj).subscribe(response => {
        if (response.success) {
          this.httpAlertService.success(this.translate.instant(response.message));
          this.isLoading2 = false;
          this.router.navigate(['/login']);
        }
        this.isLoading2 = false;
      }, (err) => {
        this.httpAlertService.error(this.translate.instant(err.error.message));
        this.isLoading2 = false;
      });
    }
  }

  public hideModal() {
    this.showCodeModal = false;
  }

}
